<ng-container>
    <nb-card>
        <nb-card-header>Customer Contacts</nb-card-header>
        <nb-card-body>
            <pty-customer-postal [partyId]="partyId"></pty-customer-postal>
            <pty-customer-email [partyId]="partyId"></pty-customer-email>
            <pty-customer-telecom [partyId]="partyId"></pty-customer-telecom>
        </nb-card-body>
    </nb-card>    
</ng-container>

